import { render, staticRenderFns } from "./addcredits.vue?vue&type=template&id=bc375502&scoped=true"
import script from "./addcredits.vue?vue&type=script&lang=js"
export * from "./addcredits.vue?vue&type=script&lang=js"
import style0 from "./addcredits.vue?vue&type=style&index=0&id=bc375502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc375502",
  null
  
)

export default component.exports